import { render, staticRenderFns } from "./RegionDetail.vue?vue&type=template&id=76793919&scoped=true"
import script from "./RegionDetail.vue?vue&type=script&lang=js"
export * from "./RegionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76793919",
  null
  
)

export default component.exports